var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:"h-5 w-5 fill-current",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }